import { useEffect, useMemo, useRef } from 'react';
import { debounce } from 'redux-bundler';

export const useResize = (onChange) => {
  const resizeTimer = useRef(null);

  const handleResize = useMemo(
    () =>
      debounce(() => {
        // disable animations while resizing the screen
        document.body.classList.add('resize-animation-stopper');

        // clear any existing timeout
        clearTimeout(resizeTimer.current);

        // set new timer to re-enable the animation
        resizeTimer.current = setTimeout(
          () => document.body.classList.remove('resize-animation-stopper'),
          400,
        );

        // update the window size
        onChange({
          height: `${window.innerHeight}px`,
          width: `${window.innerWidth}px`,
        });
      }, 200),
    [onChange],
  );

  useEffect(() => {
    // on resize, update window height, width in our theme
    // Fix for Safari/Android browsers to accurately get the viewport (100vh) height
    window.addEventListener('resize', handleResize);

    // cleanup event listener on exit
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);
};
